import React from 'react';

function Plus(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="18" 
            viewBox="0 0 20 18" 
            fill="none"
            className={className}
        >
            <path 
                d="M9.46468 16.881C9.26642 16.881 9.09789 16.8216 8.95911 16.7026C8.84015 16.5638 8.78067 16.3953 8.78067 16.197V10.0112H2.68401C2.48575 10.0112 2.31722 9.95167 2.17844 9.83271C2.05948 9.69393 2 9.5254 2 9.32714V8.37546C2 8.1772 2.05948 8.01859 2.17844 7.89963C2.31722 7.76084 2.48575 7.69145 2.68401 7.69145H8.78067V1.68401C8.78067 1.48575 8.84015 1.32714 8.95911 1.20818C9.09789 1.06939 9.26642 1 9.46468 1H10.5056C10.7038 1 10.8625 1.06939 10.9814 1.20818C11.1202 1.32714 11.1896 1.48575 11.1896 1.68401V7.69145H17.316C17.5143 7.69145 17.6729 7.76084 17.7918 7.89963C17.9306 8.01859 18 8.1772 18 8.37546V9.32714C18 9.5254 17.9306 9.69393 17.7918 9.83271C17.6729 9.95167 17.5143 10.0112 17.316 10.0112H11.1896V16.197C11.1896 16.3953 11.1202 16.5638 10.9814 16.7026C10.8625 16.8216 10.7038 16.881 10.5056 16.881H9.46468Z" 
                fill={fill}
            />
        </svg>
    )
};

export default Plus;